// ----------------------------- IE pain ------------------------------------ //
import "react-app-polyfill/ie11";
import "react-app-polyfill/ie9";
import "core-js/es/array";
import "core-js/es/object";
import "core-js/es/string";
import "core-js/es/number";
import "core-js/es/parse-float";
import "core-js/es/parse-int";
import "core-js/es/function";
import "core-js/es/math";
import "core-js/es/date";
import "core-js/es/regexp";
import "core-js/es/symbol";

// ----------------------------- IE pain ------------------------------------ //

import { watch, reactRender } from "./domListener";
import * as serviceWorker from "./serviceWorker";
import { unregister } from "./serviceWorker";

import "@fortawesome/fontawesome-pro/css/all.css";
import "@fortawesome/fontawesome-pro/css/all.css";
import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";

import { Config } from "./Config";

if (Config.domWatcher) {
    window["watch"] = watch;
    window["reactRender"] = reactRender;

    if (window["reactBuilder"] != null) {
        window["reactBuilder"]();
    }
}

if (Config.mainAppStart) {
    const comp = <App />;
    if (document.getElementById("root"))
        ReactDOM.render(<React.StrictMode>{comp}</React.StrictMode>, document.getElementById("root"));
}

if (Config.drupalComponentInject) {
    window["reactRender"] = reactRender;

    if (window["reactBuilder"] != null) {
        window["reactBuilder"]();
    }
}

serviceWorker.unregister();
unregister();
